import {sum} from 'ramda'

export const getSplitAmounts = (transaction, entries) => {
  const splitAmounts = entries.map(({inputAmount}) => parseFloat(inputAmount))
  const sumOfSplitAmounts = parseFloat(sum(splitAmounts).toFixed(2))
  const transactionAmount = parseFloat(transaction?.amount)
  if (
    (transaction?.actions?.canSplitTransaction && transactionAmount > sumOfSplitAmounts) ||
    splitAmounts.length > 1
  ) {
    const remainingAmount = parseFloat((transactionAmount - sumOfSplitAmounts).toFixed(2))
    return {
      canSplit: true,
      parts: [...splitAmounts, remainingAmount > 0 ? remainingAmount : []],
    }
  }
  return {
    canSplit: false,
    parts: [],
  }
}
